//140
import { useGLTF } from '@react-three/drei';
import { Shadow } from './_shadow';
import React, { useContext, useEffect, useRef, useState } from 'react';
import CurrentContext from '../../utils/CurrentContext';
import useSetMaterialFinish from '../../utils/useSetMaterialFinish';
import { handleExportGLTF } from '../../utils/jsHelper';
import {
  Buffer,
  PaintColorMaterial,
  WoodTopMaterial,
  WoodTopPaintColorMaterial,
} from '../../utils/materials';

//Multi-variant model
export function Breakers_dining_table(props) {
  const { variantName } = useContext(CurrentContext);

  return (
    <>
      {variantName === 'Seats 4' && <Breakers_dining_table_4_Seat />}
      {variantName === 'Seats 6' && <Breakers_dining_table_6_Seat />}
      {variantName === 'Seats 8' && <Breakers_dining_table_8_Seat />}
    </>
  );
}

export function Breakers_dining_table_4_Seat(props) {
  const { nodes, materials, scene } = useGLTF(
    'models/Breakers Dining Table_4_Seat.glb',
  );

  const arRef = useRef();
  const [currentScene, setCurrentScene] = useState(
    arRef?.current?.parent?.children.find(
      (item) => item.name === 'Mainecottage',
    ),
  );

  const {
    currentFinishes,
    defaultFinish,
    currentMaterialFinish,
    setLoading,
    setIsARReady,
    setARModelSrc,
    setARUnicode,
    isAR,
    setIsAR,
    aoIntensity,
  } = useContext(CurrentContext);

  useSetMaterialFinish(
    PaintColorMaterial,
    currentMaterialFinish.paintColorFinish,
    defaultFinish.paintColorFinish,
    'ao-breakers_dining_table_4_seat-paint_color',
    aoIntensity,
  );
  useSetMaterialFinish(
    WoodTopPaintColorMaterial,
    currentMaterialFinish.paintColorFinish,
    defaultFinish.paintColorFinish,
    'ao-breakers_dining_table_4_seat-wood_top',
    aoIntensity,
  );
  useSetMaterialFinish(
    WoodTopMaterial,
    currentMaterialFinish.woodTopFinish,
    defaultFinish.woodTopFinish,
    'ao-breakers_dining_table_4_seat-wood_top',
    aoIntensity,
  );

  useEffect(() => {
    setCurrentScene(
      arRef?.current?.parent?.children.find(
        (item) => item.name === 'Mainecottage',
      ),
    );
  }, [arRef, currentMaterialFinish]);

  useEffect(() => {
    console.log('currentScene', currentScene);
  }, [currentScene]);

  useEffect(() => {
    if (isAR && currentScene) {
      handleExportGLTF({
        currentScene,
        scene,
        fileName: 'maine_cottage',
        setLoading,
      }).then(({ file, unicode } = {}) => {
        setARModelSrc(file);
        setIsARReady(true);
        setARUnicode(unicode);
      });
    }
    setIsAR(false);
  }, [isAR, currentScene]);

  return (
    <group name={'Mainecottage'} dispose={null} visible={true} ref={arRef}>
      <mesh
        castShadow
        geometry={nodes.Paint_Color.geometry}
        material={PaintColorMaterial}
      />
      <mesh castShadow geometry={nodes.Buffer.geometry} material={Buffer} />
      {currentMaterialFinish?.woodTopFinish?.name === 'Painted' ? (
        <mesh
          castShadow
          geometry={nodes.Wood_Top.geometry}
          material={WoodTopPaintColorMaterial}
        />
      ) : (
        <mesh
          castShadow
          geometry={nodes.Wood_Top.geometry}
          material={WoodTopMaterial}
        />
      )}
      <Shadow model={'Breakers Dining Table_4_Seat'} />
    </group>
  );
}

export function Breakers_dining_table_6_Seat(props) {
  const { nodes, materials, scene } = useGLTF(
    'models/Breakers Dining Table_6_Seat.glb',
  );

  const arRef = useRef();
  const [currentScene, setCurrentScene] = useState(
    arRef?.current?.parent?.children.find(
      (item) => item.name === 'Mainecottage',
    ),
  );

  const {
    currentFinishes,
    defaultFinish,
    currentMaterialFinish,
    setLoading,
    setIsARReady,
    setARModelSrc,
    setARUnicode,
    isAR,
    setIsAR,
    aoIntensity,
  } = useContext(CurrentContext);

  useSetMaterialFinish(
    PaintColorMaterial,
    currentMaterialFinish.paintColorFinish,
    defaultFinish.paintColorFinish,
    'ao-breakers_dining_table_6_seat-paint_color',
    aoIntensity,
  );
  useSetMaterialFinish(
    WoodTopPaintColorMaterial,
    currentMaterialFinish.paintColorFinish,
    defaultFinish.paintColorFinish,
    'ao-breakers_dining_table_6_seat-wood_top',
    aoIntensity,
  );
  useSetMaterialFinish(
    WoodTopMaterial,
    currentMaterialFinish.woodTopFinish,
    defaultFinish.woodTopFinish,
    'ao-breakers_dining_table_6_seat-wood_top',
    aoIntensity,
  );

  useEffect(() => {
    setCurrentScene(
      arRef?.current?.parent?.children.find(
        (item) => item.name === 'Mainecottage',
      ),
    );
  }, [arRef, currentMaterialFinish]);

  useEffect(() => {
    console.log('currentScene', currentScene);
  }, [currentScene]);

  useEffect(() => {
    if (isAR && currentScene) {
      handleExportGLTF({
        currentScene,
        scene,
        fileName: 'maine_cottage',
        setLoading,
      }).then(({ file, unicode } = {}) => {
        setARModelSrc(file);
        setIsARReady(true);
        setARUnicode(unicode);
      });
    }
    setIsAR(false);
  }, [isAR, currentScene]);

  return (
    <group name={'Mainecottage'} dispose={null} visible={true} ref={arRef}>
      <mesh castShadow geometry={nodes.Buffer.geometry} material={Buffer} />
      <mesh
        castShadow
        geometry={nodes.Paint_Color.geometry}
        material={PaintColorMaterial}
      />
      {currentMaterialFinish?.woodTopFinish?.name === 'Painted' ? (
        <mesh
          castShadow
          geometry={nodes.Wood_Top.geometry}
          material={WoodTopPaintColorMaterial}
        />
      ) : (
        <mesh
          castShadow
          geometry={nodes.Wood_Top.geometry}
          material={WoodTopMaterial}
        />
      )}
      <Shadow model={'Breakers Dining Table_6_Seat'} />
    </group>
  );
}

//Buffer colour does not match other variants
export function Breakers_dining_table_8_Seat(props) {
  const { nodes, materials, scene } = useGLTF(
    'models/Breakers Dining Table_8_Seat.glb',
  );

  const arRef = useRef();
  const [currentScene, setCurrentScene] = useState(
    arRef?.current?.parent?.children.find(
      (item) => item.name === 'Mainecottage',
    ),
  );

  const {
    currentFinishes,
    defaultFinish,
    currentMaterialFinish,
    setLoading,
    setIsARReady,
    setARModelSrc,
    setARUnicode,
    isAR,
    setIsAR,
    aoIntensity,
  } = useContext(CurrentContext);

  useSetMaterialFinish(
    PaintColorMaterial,
    currentMaterialFinish.paintColorFinish,
    defaultFinish.paintColorFinish,
    'ao-breakers_dining_table_8_seat-paint_color',
    aoIntensity,
  );
  useSetMaterialFinish(
    WoodTopPaintColorMaterial,
    currentMaterialFinish.paintColorFinish,
    defaultFinish.paintColorFinish,
    'ao-breakers_dining_table_8_seat-wood_top',
    aoIntensity,
  );
  useSetMaterialFinish(
    WoodTopMaterial,
    currentMaterialFinish.woodTopFinish,
    defaultFinish.woodTopFinish,
    'ao-breakers_dining_table_8_seat-wood_top',
    aoIntensity,
  );

  useEffect(() => {
    setCurrentScene(
      arRef?.current?.parent?.children.find(
        (item) => item.name === 'Mainecottage',
      ),
    );
  }, [arRef, currentMaterialFinish]);

  useEffect(() => {
    console.log('currentScene', currentScene);
  }, [currentScene]);

  useEffect(() => {
    if (isAR && currentScene) {
      handleExportGLTF({
        currentScene,
        scene,
        fileName: 'maine_cottage',
        setLoading,
      }).then(({ file, unicode } = {}) => {
        setARModelSrc(file);
        setIsARReady(true);
        setARUnicode(unicode);
      });
    }
    setIsAR(false);
  }, [isAR, currentScene]);

  return (
    <group name={'Mainecottage'} dispose={null} visible={true} ref={arRef}>
      <mesh castShadow geometry={nodes.Buffer.geometry} material={Buffer} />
      <mesh
        castShadow
        geometry={nodes.Paint_Color.geometry}
        material={PaintColorMaterial}
      />
      {currentMaterialFinish?.woodTopFinish?.name === 'Painted' ? (
        <mesh
          castShadow
          geometry={nodes.Wood_Top.geometry}
          material={WoodTopPaintColorMaterial}
        />
      ) : (
        <mesh
          castShadow
          geometry={nodes.Wood_Top.geometry}
          material={WoodTopMaterial}
        />
      )}
      <Shadow model={'Breakers Dining Table_8_Seat'} />
    </group>
  );
}
